// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__RN8D0","popup":"styles_popup__is24K","icon":"styles_icon__sJZJi"};